/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../../types/graph';

import { PolicyPreferencesFieldsFragment } from '../../../../fragments/lifeApplication/policyPreferencesType';
import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PolicyPreferencesUpdateMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.PolicyPreferencesUpdateMutationInput;
}>;


export type PolicyPreferencesUpdateMutation = { __typename?: 'Mutation', life_applications: { __typename?: 'LifeApplications', policy: { __typename?: 'PolicyMutation', policy_preferences_update: (
        { __typename?: 'LifePolicyPreferences', id: string | null }
        & PolicyPreferencesFieldsFragment
      ) | null } } };


export function usePolicyPreferencesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PolicyPreferencesUpdateMutation, PolicyPreferencesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PolicyPreferencesUpdateMutation, PolicyPreferencesUpdateMutationVariables>(Operations.policyPreferencesUpdate, options);
      }
export type PolicyPreferencesUpdateMutationHookResult = ReturnType<typeof usePolicyPreferencesUpdateMutation>;